import { render, staticRenderFns } from "./QuestionOptionForm.vue?vue&type=template&id=32ef5334"
import script from "./QuestionOptionForm.vue?vue&type=script&lang=js"
export * from "./QuestionOptionForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports